import React from 'react';
import styled from 'styled-components';
import Card from './ArticleCard';

import {mediaQueries} from '../shared/config'


const card_height = 380 + 44;   // height of card + pushpin
const card_width = 385;         // width of card

export default function ArticleRow(props)
{
    const Container = styled.div ` 
        display: flex;
        flex-direction: row;

        justify-content: center;
        padding-top: ${0.4*card_height}px;
        padding-bottom: ${0.4*card_height}px;
        column-gap: ${card_width * 0.1}px;
        background-color: #${props.background_color};
        background-image: url(${props.background_image});
        background-size: 100% 100%;
        background-repeat: no-repeat;
        min-width: 100vw;
        background-size: cover;
        ${mediaQueries.mobile} {
            flex-direction: column;
            align-items: center;
            justify-content: center;
            row-gap: ${card_height * 0.2}px;
            padding-top: ${0.2*card_height}px;
            padding-bottom: ${0.2*card_height}px;
            width: 100vw;
        }
    `

    return (
        <Container>
            {props && props.articles ? props.articles.map((article) => {
                console.log(article);
                return(
                    <Card article_title={article.article_title} article_byline={article.article_byline} article_image={article.article_image} article_url={article.article_url}/>
                )
            }) : null}
        </Container>
    )
}